<template>
  <div class="recommendedBrandsForCategory container">
    <SectionContainer :title="data.title">
      <div class="recommendedBrandsForCategory__content">
        <SliderLogotypes :items="items" />
      </div>
    </SectionContainer>
  </div>
</template>

<script>
import CategoriesWithListGrid from '@/components/CategoriesWithListGrid.vue';
import SectionContainer from '@/components/SectionContainer.vue';
import SliderLogotypes from '@/components/Sliders/SliderLogotypes.vue';

export default {
  name: 'RecommendedBrandsForCategory',
  components: { SliderLogotypes, SectionContainer, CategoriesWithListGrid },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    brands: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    items() {
      return this.brands.map(({ name, logoUrl100x80, id, slug }) => ({
        name,
        image: logoUrl100x80,
        id,
        to: this.localePath({
          name: 'brand-slug',
          params: {
            slug,
          },
        }),
      }));
    },
  },
};
</script>

<style scoped lang="scss">
.recommendedBrandsForCategory {
  &__content {
    padding: 2rem 0;
  }
}
</style>
